import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';
import { BillingV2Service } from '@core/services';
import { BillingApiAccountResponseDto } from '@lingo2-billing-sdk/models';
import { ChangableComponent } from '@models/changable.component';

import { CustomLocaleService } from '@onclass/oc-custom-locale';
import { IconComponent } from '@shared/icon/icon.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { takeUntil } from 'rxjs/operators';

/*
 */
@Component({
  selector: 'app-transactions-filter',
  standalone: true,
  imports: [LocaleSharedModule, CommonModule, IconComponent],
  templateUrl: './transactions-filter.component.html',
  styleUrls: ['./transactions-filter.component.scss'],
})
export class TransactionsFilterComponent extends ChangableComponent implements OnInit {
  billingV2Service = inject(BillingV2Service);
  t_srv = inject(CustomLocaleService);
  deviceService = inject(DeviceDetectorService);

  @Input() position = 'popup-left';
  @Input() id: string;
  @Output() onChange = new EventEmitter<string | null>();

  public popup_open = false;
  public selectedProvider: string;
  public accounts: BillingApiAccountResponseDto[] = [];

  ngOnInit(): void {
    this.selectedProvider = this.t_srv.instant('transaction-history.for-all');
    this.billingV2Service
      .getAccounts()
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (accounts) => {
          this.accounts = accounts;
          this.detectChanges();
        },
        error: (error) => {
          this.errorNotificationService.captureError(error, 'PAYMENT-PROBLEM');
          this.detectChanges();
        },
      });
    this.detectChanges();
  }

  public filterByProvider(account: BillingApiAccountResponseDto) {
    this.onChange.emit(account?.providerId);
    this.selectedProvider = this.getProvider(account?.cardAccount?.label);
    this.popup_open = false;
  }

  public getProvider(label: string) {
    if (!label) {
      return this.t_srv.instant('transaction-history.for-all');
    }
    return this.t_srv.instant('transaction-history.card') + ' **** **** **** ' + label;
  }

  public popupState(arg) {
    this.popup_open = arg;
  }
}
